export enum TabsCollection {
  'details' = 'details',
  'volumes' = 'volumes',
  'forecast' = 'forecast',
  'networkAllocation' = 'networkAllocation',
  'certificateOperations' = 'certificateOperations',
  'garanteesOfOrigin' = 'garanteesOfOrigin',
}
